export default __webpack_public_path__ + "static/char-v-42-ja-2a632b495aeb999a16258ff36e8c5068.mp4";